import { userRoles, sportKinds, genders } from '../../utils/constants'
import { uploadFile } from './configureDataBeforeRecord'

export async function transformData(data) {
  if (data?.city?.id) {
    data.city = `/cities/${data.city.id}`
  }
  if (data?.organizationCity?.id) {
    data.organizationCity = `/cities/${data.organizationCity.id}`
  }
  if (data?.avatar?.id) {
    data.avatar = `/files/${data.avatar.id}`
  }
  if (data.poster?.rawFile instanceof File) {
    data.poster = await uploadFile(data.poster)
  } else {
    delete data.poster
  }
  if (data?.fightBelts && Array.isArray(data.fightBelts)) {
    data.fightBelts = data.fightBelts.map(belt => {
      if (belt?.id) {
        return `/fight_belts/${belt.id}`
      }
      return belt
    })
  }
  if (data?.sportsCategory?.id) {
    data.sportsCategory = `/sports_categories/${data.sportsCategory.id}`
  }

  return data
}

export const RolesOptions = Object.values(userRoles).map((option) => ({
  id: option.textEN,
  name: option.text,
}))
export const RolesKeyOptions = Object.entries(userRoles).map(
  ([key, option]) => ({
    id: key,
    name: option.text,
  })
)
export const SportKindsOptions = Object.values(sportKinds).map((option) => ({
  id: option.value,
  name: option.text,
}))
export const GendersOptions = Object.values(genders).map((option) => ({
  id: option.value,
  name: option.text,
}))

export const getDeepClone = (data) => JSON.parse(JSON.stringify(data))
